<template>
  <div>
    <div class="header">
      <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/r2.png" />
      <div class="wrap1">
        <span class="word3">请确认填写基本信息。</span>
        <span class="word4">请认真核对填写，一旦提交不可修改。</span>
      </div>
    </div>
    <!-- 根据用户在步骤一点击的是个人还是课程方动态生成对应的子组件 -->
    <div class="box3 flex-col"></div>
    <a-form :form="form">
      <!-- 个人注册 -->
      <div
        v-if="this.$store.state.register.form.institutionType === 2"
        id="components-form-demo-vuex"
      >
        <a-row :gutter="24">
          <a-col :span="24">
            <div class="font">姓名</div>
            <a-form-item :wrapperCol="{ lg: { span: 8 } }">
              <a-input
                v-decorator="[
                  'username',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^[\u4e00-\u9fa5a-zA-Z]{2,10}$/,
                        message: '请输入长度为2~10位的姓名',
                      },
                    ],
                    getValueFromEvent: (event) => {
                      return /^[\u4e00-\u9fa5a-zA-Z]+$/.test(event.target.value)
                        ? event.target.value
                        : event.target.value.slice(0, -1)
                    },
                  },
                ]"
                placeholder="请输入您的真实姓名"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <div class="font">主要联络手机</div>
            <a-form-item :wrapperCol="{ lg: { span: 17 } }">
              <a-input
                v-decorator="[
                  'mobile',
                  {
                    rules: [{ validator: mobileRules }],
                    validateTrigger: 'blur',
                    getValueFromEvent: (event) => {
                      return /^\d+$/.test(event.target.value)
                        ? event.target.value
                        : ''
                    },
                  },
                ]"
                placeholder="请输入您常用的手机号" :maxLength="11"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <div class="font">验证码</div>
            <a-form-item
              :labelCol="{ lg: { span: 1 } }"
              :wrapperCol="{ lg: { span: 15 } }"
            >
              <a-row :gutter="24">
                <a-col :span="20">
                  <a-input
                    v-decorator="[
                      'smsCode',
                      {
                        rules: [
                          {
                            required: true,
                            pattern: /^\d{6}$/,
                            message: '请输入收到的验证码',
                          },
                        ],
                        getValueFromEvent: (event) => {
                          return /^\d+$/.test(event.target.value)
                            ? event.target.value
                            : ''
                        },
                      },
                    ]"
                    placeholder="请输入收到的验证码" :maxLength="6"
                  />
                </a-col>
                <a-col :span="2">
                  <a-button @click.stop.prevent="getCode">{{
                    this.state.time === 0 || this.state.time === 60
                      ? '获取验证码'
                      : `${this.state.time}s后再次发送`
                  }}</a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <div class="font">密码</div>
            <a-form-item :wrapperCol="{ lg: { span: 8 } }">
              <a-input
                v-decorator="[
                  'password',
                  {
                    rules: [{ validator: handleConfirmPass }],
                    validateTrigger: 'blur',
                  },
                ]"
                placeholder="请设置您的密码"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>
      <!-- 课程方注册 -->
      <div
        v-if="this.$store.state.register.form.institutionType === 1"
        id="components-form-demo-vuex"
      >
        <a-row :gutter="24">
          <a-col :span="13">
            <div class="font">课程方名称</div>
            <a-form-item :wrapperCol="{ lg: { span: 17 } }">
              <a-input
                :maxLength="45"
                v-decorator="[
                  'institutionName',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^.{2,45}$/,
                        message: '请输入长度为2~45位的课程方名字',
                      },
                    ],
                    getValueFromEvent: (event) => {
                      return /^[\u4e00-\u9fa5a-zA-Z]+$/.test(event.target.value)
                        ? event.target.value
                        : event.target.value.slice(0, -1)
                    },
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                placeholder="请输入课程方名"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <div class="font">负责人姓名</div>
            <a-form-item
              :labelCol="{ lg: { span: 1 } }"
              :wrapperCol="{ lg: { span: 15 } }"
            >
              <a-input
                v-decorator="[
                  'username',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^[\u4e00-\u9fa5a-zA-Z]{2,10}$/,
                        message: '请输入长度为2~10位的负责人姓名',
                      },
                    ],
                    getValueFromEvent: (event) => {
                      return /^[\u4e00-\u9fa5a-zA-Z]+$/.test(event.target.value)
                        ? event.target.value
                        : event.target.value.slice(0, -1)
                    },
                    validateTrigger: 'change',
                  },
                ]"
                placeholder="请输入负责人的真实姓名"
              />
            </a-form-item>
          </a-col>
          <a-col :span="13">
            <div class="font">负责人手机</div>
            <a-form-item :wrapperCol="{ lg: { span: 17 } }">
              <a-input
                :maxLength="11"
                ref="input"
                v-decorator="[
                  'mobile',
                  {
                    rules: [{ validator: mobileRules }],
                    validateTrigger: 'blur',
                    getValueFromEvent: (event) => {
                      return /^\d+$/.test(event.target.value)
                        ? event.target.value
                        : ''
                    },
                  },
                ]"
                placeholder="请输入课程方负责人的手机号"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <div class="font">验证码</div>
            <a-form-item
              :labelCol="{ lg: { span: 1 } }"
              :wrapperCol="{ lg: { span: 15 } }"
            >
              <a-row :gutter="24">
                <a-col :span="20">
                  <a-input
                    defaultOpen="false"
                    v-decorator="[
                      'smsCode',
                      {
                        rules: [
                          {
                            required: true,
                            pattern: /^\d{6}$/,
                            message: '请输入验证码',
                          },
                        ],
                        getValueFromEvent: (event) => {
                          return /^\d+$/.test(event.target.value)
                            ? event.target.value
                            : ''
                        },
                      },
                    ]"
                    placeholder="请输入收到的验证码" :maxLength="6"
                  />
                </a-col>
                <a-col :span="2">
                  <a-button @click.stop.prevent="getCode">{{
                    this.state.time === 0 || this.state.time === 60
                      ? '获取验证码'
                      : `${this.state.time}s后再次发送`
                  }}</a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <div class="font">密码</div>
            <a-form-item :wrapperCol="{ lg: { span: 9 } }">
              <a-input
                v-decorator="[
                  'password',
                  {
                    rules: [{ validator: handleConfirmPass }],
                    validateTrigger: 'blur',
                  },
                ]"
                placeholder="请设置账号密码"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>
      <!-- 高校与协会 -->
      <div
        v-if="this.$store.state.register.form.institutionType === 3"
        id="components-form-demo-vuex"
      >
        <a-row :gutter="24">
          <a-col :span="24">
            <div class="font">邀请码</div>
            <a-form-item :wrapperCol="{ lg: { span: 9 } }">
              <a-input
                :maxLength="8"
                v-decorator="[
                  'inviteCode',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^[\d\a-zA-Z]{8}$/,
                        message: '请输入由英文和数字组成长度为8位的邀请码',
                      },
                    ],
                    getValueFromEvent: (event) => {
                      return /^[\d\a-zA-Z]{8}$/.test(event.target.value)
                        ? event.target.value
                        : event.target.value.trim()
                    },
                  },
                ]"
                placeholder="请输入邀请码"
              />
            </a-form-item>
          </a-col>
          <a-col :span="13">
            <div class="font">高校与协会名称</div>
            <a-form-item :wrapperCol="{ lg: { span: 17 } }">
              <a-input
                v-decorator="[
                  'institutionName',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^[\u4e00-\u9fa5a-zA-Z]{2,25}$/,
                        message: '请输入长度为2~25位的高校与协会名称',
                      },
                    ],
                    getValueFromEvent: (event) => {
                      return /^[\u4e00-\u9fa5a-zA-Z]+$/.test(event.target.value)
                        ? event.target.value
                        : event.target.value.slice(0, -1)
                    },
                  },
                ]"
                placeholder="请输入高校与协会名称"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <div class="font">联系人姓名</div>
            <a-form-item
              :labelCol="{ lg: { span: 1 } }"
              :wrapperCol="{ lg: { span: 15 } }"
            >
              <a-input
                v-decorator="[
                  'username',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^[\u4e00-\u9fa5a-zA-Z]{2,10}$/,
                        message: '请输入长度为2~10位的联系人姓名',
                      },
                    ],
                    getValueFromEvent: (event) => {
                      return /^[\u4e00-\u9fa5a-zA-Z]+$/.test(event.target.value)
                        ? event.target.value
                        : event.target.value.slice(0, -1)
                    },
                  },
                ]"
                placeholder="请输入联系人的真实姓名"
              />
            </a-form-item>
          </a-col>
          <a-col :span="13">
            <div class="font">联系人手机号</div>
            <a-form-item :wrapperCol="{ lg: { span: 17 } }">
              <a-input
                :maxLength="11"
                ref="input"
                v-decorator="[
                  'mobile',
                  {
                    rules: [{ validator: mobileRules }],
                    validateTrigger: 'blur',
                    getValueFromEvent: (event) => {
                      return /^\d+$/.test(event.target.value)
                        ? event.target.value
                        : ''
                    },
                  },
                ]"
                placeholder="请输入联系人的手机号"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <div class="font">验证码</div>
            <a-form-item
              :labelCol="{ lg: { span: 1 } }"
              :wrapperCol="{ lg: { span: 15 } }"
            >
              <a-row :gutter="24">
                <a-col :span="20">
                  <a-input
                    defaultOpen="false"
                    v-decorator="[
                      'smsCode',
                      {
                        rules: [
                          {
                            required: true,
                            pattern: /^\d{6}$/,
                            message: '请输入验证码',
                          },
                        ],
                        getValueFromEvent: (event) => {
                          return /^\d+$/.test(event.target.value)
                            ? event.target.value
                            : ''
                        },
                      },
                    ]"
                    placeholder="请输入收到的验证码" :maxLength="6"
                  />
                </a-col>
                <a-col :span="2">
                  <a-button @click.stop.prevent="getCode">{{
                    this.state.time === 0 || this.state.time === 60
                      ? '获取验证码'
                      : `${this.state.time}s后再次发送`
                  }}</a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <div class="font">密码</div>
            <a-form-item :wrapperCol="{ lg: { span: 9 } }">
              <a-input
                v-decorator="[
                  'password',
                  {
                    rules: [{ validator: handleConfirmPass }],
                    validateTrigger: 'blur',
                  },
                ]"
                placeholder="请设置账号密码"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>
      <div class="outer9 flex-col"></div>
      <div class="footer">
        <div style="height: 1px; width: 100%; color: #000"></div>
        <a-col :span="12">
          <a-form-item :wrapper-col="{ span: 12, offset: 16 }">
            <a-button class="button" @click="last" type="primary" ghost>
              上一步
            </a-button>
          </a-form-item>
        </a-col>

        <a-col :span="12">
          <a-form-item :wrapper-col="{ span: 10, offset: 0 }">
            <a-button
              @click="next"
              class="button"
              type="primary"
              html-type="submit"
            >
              下一步
            </a-button>
          </a-form-item>
        </a-col>
      </div>
    </a-form>
    <a-modal v-model="qrCodeShow" title="请通过微信扫码" :closable="false" :maskClosable="false" okText="我已扫码并确认" :centered="true" @ok="qrCodeOK" width="328px"
     cancelText=" " :cancelButtonProps="{props: {type:'link',disabled:true}, on: {}}">
      <img :src="qrCodeData">
      <p v-if="this.qrCodeCountdown>0">微信中确认手机号正确({{ this.qrCodeCountdown }})</p>
    </a-modal>
  </div>
</template>
<script>
import bureau from '../../../api/bureau'
import user from '../../../api/user'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      state: {
        time: 60,
      },
      id: '',
      qrCodeData: null,
      qrCodeShow: false,
      qrCodeCountdown: 120
    }
  },
  created() {
    bureau.getBureauId().then((res) => {
      this.id = res
    })
  },

  methods: {
    mobileRules(rule, value, callback) {
      if (!value) {
        callback('请输入常用的手机号')
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback('请输入正确的手机号')
      }
      callback()
    },
    handleConfirmPass(rule, value, callback) {
      if (!value) {
        callback(
          '请输入8-20位密码，需包含大小写字母、数字，字符不支持中文格式。'
        )
      } else if (!/^[\u0020-\u007e]{8,20}$/.test(value)) {
        callback('请输入长度为8~20位的密码')
      } else if (!/[A-Z]+/.test(value)) {
        callback('密码中需要包含大写字母')
      } else if (!/[a-z]+/.test(value)) {
        callback('密码中需要包含小写字母')
      } else if (!/\d+/.test(value)) {
        callback('密码中需要包含数字')
      }
      callback()
    },
    //点击下一步进行校验并且将当前组件信息存储至vuex中
    next(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.$store.commit('register/changeInformation', {
            ...values,
            bureauId: this.id,
          })
          // console.log('Received values of form: ', values)
          console.log('3下一步', this.$store.state.register.form)

          await user
            .registerAfterSchool(this.$store.state.register.form)
            .then((res) => {
              console.log(res)
              this.$ls.set('token', res.data.accessToken)
              this.$emit('nextStep', 1)
            })
            .catch((e) => {
              console.log('e', e)
            })
        }
        return
      })
    },
    last() {
      this.$emit('lastStep', 1)
    },
    //发送验证码
    getCode(e) {
      e.preventDefault()
      this.form.validateFields(['mobile'], (err, values) => {
        if (!err) {
          if (60 > this.state.time > 0) {
            return
          }
          const hide = this.$message.loading('验证码发送中..', 0)
          let timerId = null;
          // console.log(values.mobile)
          var _this = this;
          var countDown = null;
          user
            .getSmscode({ mobile: values.mobile, mode: 'provider_regist' })
            .then((res) => {
              if (res.code==0) {
                if (res.ScanCode) {
                  _this.qrCodeData = res.ScanCode;
                  _this.qrCodeShow = true;
                  countDown = setInterval(()=>{
                    _this.qrCodeCountdown--;
                    if (_this.qrCodeCountdown==0 && countDown!=null) {
                      clearInterval(countDown)
                    }
                  }, 1000)
                }
              } else {
                _this.$warning({content: res.msg+"("+res.code+")"})
              }
              setTimeout(hide, 2500);
            })
            .catch((err) => {
              console.error('错误信息：', err)
              setTimeout(hide, 1)
              if (timerId)
                clearInterval(timerId)
              this.state.time = 60
            })
          
          //发送请求，获取验证码
          timerId = window.setInterval(() => {
            this.state.time -= 1
            if (this.state.time === 0) {
              clearInterval(timerId)
              this.state.time = 60
            }
          }, 1000)
        } else {
          this.$refs.input.focus()
          return
        }
      })
    },
    qrCodeOK(e) {
      this.qrCodeData = null;
      this.qrCodeShow = false;
      this.qrCodeCountdown = 120;
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  margin: 13px 0 0 6px;
}
.pic1 {
  z-index: 23;
  width: 50px;
  height: 50px;
}
.wrap1 {
  display: inline-block;
  height: 50px;
  vertical-align: middle;
  margin-left: 23px;
  .word3 {
    display: block;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
  }
  .word4 {
    color: rgba(135, 136, 138, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    margin-top: 8px;
  }
}
.box3 {
  z-index: 19;
  width: 100%;
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: center;
  margin: 37px 10px 30px 10px;
}

#components-form-demo-vuex .language-bash {
  max-width: 400px;
  border-radius: 6px;
  margin-top: 24px;
}
.ant-form {
  padding-left: 39px;
}
.font {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
}

.button {
  width: 140px;
  height: 42px;
  border-radius: 4px;
}
.outer9 {
  z-index: 37;
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
